import styles from '@/components/app/upgrade/QAsection.module.css';
import { Collapse, ConfigProvider, Flex, theme } from 'antd';
import Link from 'next/link';
import useSWR from 'swr';

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

function QASection() {
   const { token } = theme.useToken();
   const { data, isLoading, error } = useSWR('/api/faqs');

   const getItems = (panelStyle) => {
      return data?.FAQs?.nodes?.map((item) => {
         return {
            key: item?.id,
            label: item?.title,
            children: (
               <div style={{ backgroundColor: 'transparent' }} dangerouslySetInnerHTML={{ __html: item?.content }} />
            ),
            style: panelStyle,
         };
      });
   };

   const panelStyle = {
      marginBottom: 24,
      background: token.colorFillAlter,
      borderRadius: token.borderRadiusLG,
      border: 'none',
      padding: token.padding,
   };
   return (
      <ConfigProvider
         theme={{
            token: {
               colorText: '#8E8E9E',
               colorTextHeading: 'black',
               fontSize: 16,
               borderRadiusLG: 8,
               colorBorder: 'none',
               fontFamily: 'Poppins, sans-serif',
            },
            components: {
               Collapse: {
                  contentBg: '#000',
                  contentPadding: 16,
               },
            },
         }}
      >
         <Flex vertical style={{ width: '90%', padding: '0 0 100px' }} align="center" gap={16}>
            <p style={{ fontSize: '40px' }}>FAQ's</p>

            <Collapse
               variant="borderless"
               defaultActiveKey={['0']}
               expandIconPosition="end"
               style={{
                  background: token.colorBgContainer,
                  fontWeight: '600',
                  width: '80%',
                  borderRadius: '8px',
               }}
            >
               {getItems(panelStyle)?.map((panel) => (
                  <Collapse.Panel className={styles['collapseHover']} key={panel?.key} header={panel?.label}>
                     {panel?.children}
                  </Collapse.Panel>
               ))}
               {isLoading && <p>loading ...</p>}
            </Collapse>
            <p style={{ color: '#8E8E9E', fontSize: '16px' }}>
               Looking for something else? Find answers to all this and more, just{' '}
               <Link style={{ color: 'blue', textDecoration: 'underline' }} href="https://premast.com/contact-us">
                  Contact Us
               </Link>
            </p>
         </Flex>
      </ConfigProvider>
   );
}

export default QASection;
